import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import DocumentCategory, {
  newDocumentCategory,
} from "../../models/document-category";
import DocumentCategoryForm from "./DocumentCategoryForm";

interface DocumentCategoryUpdateModalProps {
  show: boolean;
  documentCategory?: DocumentCategory;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const DocumentCategoryUpdateModal: React.FC<
  DocumentCategoryUpdateModalProps
> = ({ show, documentCategory, onCancel, onSuccess }) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialDocumentCategory, setInitialDocumentCategory] =
    useState<DocumentCategory>(
      documentCategory ? documentCategory : newDocumentCategory()
    );

  const modalTitle = documentCategory
    ? `Editar Categoría de documento: ${documentCategory.name}`
    : `Crear Categoría de documento nueva`;

  const onClose = () => {
    setInitialErrors({});
    setInitialDocumentCategory(newDocumentCategory());
    onCancel();
  };
  useEffect(() => {
    setInitialDocumentCategory(
      documentCategory ? documentCategory : newDocumentCategory()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentCategory]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <DocumentCategoryForm
            initialDocumentCategory={initialDocumentCategory}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default DocumentCategoryUpdateModal;
